// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar__PYHO6X","toolbarLeft":"toolbarLeft__neLWM1","toolbarRight":"toolbarRight__soPSIl","inputLabel":"inputLabel__QRZXpj","languageSelect":"languageSelect__vjxl16"};